import styled from 'styled-components';

const Form = styled.form`
  margin-bottom: 1em;
`;

export default Form;



// WEBPACK FOOTER //
// ./src/components/common/Form/index.js